import _, {parseInt} from 'lodash';
import PropTypes from 'prop-types';
import React, {Component, createRef} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {isUserBusy} from 'api/sessionApi';
import {FmlxBanner} from 'fmlx-common-ui';
import FormUserContainer from './FormUserContainer';
import FastModal from '../../components/FastModal';
import {Feedback, ModalSize} from '../../constants/dataEnum';
import {AlertUsername, AlertPassword, AlertEmail, ValidateResult} from '../../constants/editUserEnum';
import {ModalAccountRight} from '../../constants/userManagementEnum';
import InputTextHelper from '../../lib/inputTextHelper';
import withIntl from '../../lib/withIntl';
import {showLoading, hideLoading, showSnackbar, setIsAnyModalShow} from '../../stores/actions/appStateAction';
import {setSessionUser} from '../../stores/actions/sessionAction';
import {
  fetchUsers,
  createUser,
  updateUser,
  updateUserNameAndEmail,
  fetchAvailableRoleRights,
} from '../../stores/business/userManagementBusiness';
import './ModalAddEditUser.scss';

function mapStateToProps(state) {
  return {
    sessionStateUser: state.sessionState.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActionShowLoading: bindActionCreators(showLoading, dispatch),
    appStateActionHideLoading: bindActionCreators(hideLoading, dispatch),
    appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
    appStateActionSetIsAnyModalShow: bindActionCreators(setIsAnyModalShow, dispatch),
    sessionActionSetSessionUser: bindActionCreators(setSessionUser, dispatch),
    userManagementBusinessFetchUsers: bindActionCreators(fetchUsers, dispatch),
    userManagementBusinessCreateUser: bindActionCreators(createUser, dispatch),
    userManagementBusinessUpdateUser: bindActionCreators(updateUser, dispatch),
    userManagementBusinessUpdateUserNameAndEmail: bindActionCreators(updateUserNameAndEmail, dispatch),
    userManagementBusinessFetchAvailableRoleRights: bindActionCreators(fetchAvailableRoleRights, dispatch),
  };
}

class ModalAddEditUser extends Component {
  constructor(props) {
    super(props);

    const {initialData} = props;

    const {userId, username, decryptedPassword, name, email, userRole, isActive, disabled} = initialData;

    this.state = {
      userId,
      inputUsername: username,
      inputPassword: decryptedPassword ?? '',
      inputConfirmPassword: decryptedPassword,
      inputName: name,
      inputEmail: email,
      roleName: userRole,
      isActive,
      initialData: {
        userId,
        username,
        password: decryptedPassword,
        confirmPassword: decryptedPassword,
        name,
        email,
        userRole,
        isActive,
        disabled,
      },
      alertUsername: {
        type: '',
        isShow: false,
      },
      alertPassword: {
        type: '',
        isShow: false,
      },
      alertConfirmPassword: {
        type: '',
        isShow: false,
      },
      alertEmail: {
        type: '',
        isShow: false,
      },
      banner: {
        isShow: false,
        message: '',
        variant: FmlxBanner.Variant.ERROR,
      },
    };

    this.availableUsers = [];
    this.bannerRef = createRef();
  }

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  componentDidMount = async () => {
    const {userManagementBusinessFetchUsers, appStateActionSetIsAnyModalShow} = this.props;

    appStateActionSetIsAnyModalShow(true);
    const response = await userManagementBusinessFetchUsers();

    if (!response) {
      return;
    }

    this.availableUsers = response;
  };

  onChangeInputUsername = (event) => {
    const txtUsername = event.value.trim();
    const {inputPassword} = this.state;
    let alertUsername = {
      type: '',
      isShow: false,
    };
    const isUserNameAlreadyExist = this.availableUsers.find(
      (user) => user.username.toLowerCase() === txtUsername.toLowerCase(),
    );

    if (isUserNameAlreadyExist) {
      alertUsername = {
        type: AlertUsername.USERNAME_EXIST,
        isShow: true,
      };
    } else if (txtUsername === inputPassword.trim() && inputPassword.trim() !== '') {
      alertUsername = {
        type: AlertUsername.SAME_WITH_PASSWORD,
        isShow: true,
      };
    }

    this.setState({
      inputUsername: txtUsername,
      alertUsername,
    });
  };

  validatePassword = (name) => {
    const {inputUsername} = this.state;
    let errorValidate = '';

    if (name !== '') {
      if (name === inputUsername && inputUsername !== '') {
        errorValidate = AlertPassword.SAME_WITH_USERNAME;
      } else if (name.length > 0 && name.length < 8) {
        errorValidate = AlertPassword.TOO_SHORT;
      } else if (name.search(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\W\S_]{8,}$/) < 0) {
        errorValidate = AlertPassword.MUST_CONTAIN_FORMAT;
      } else {
        errorValidate = '';
      }
    }

    return errorValidate;
  };

  // eslint-disable-next-line class-methods-use-this
  validateRepeatPassword = (password, confirmPassword) => {
    if (!confirmPassword) {
      return '';
    }

    return password && confirmPassword !== password ? AlertPassword.CONFIRM_PASSWORD_NOT_MATCH : '';
  };

  // eslint-disable-next-line class-methods-use-this
  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let errorValidate = '';

    if (!re.test(String(email).toLowerCase())) {
      errorValidate = AlertEmail.EMAIL_NOT_VALID;
    } else {
      errorValidate = '';
    }

    return errorValidate;
  };

  onChangeInputPassword = async (event) => {
    const {inputConfirmPassword} = this.state;
    const txtPassword = event.value.trim();
    const validatePassword = this.validatePassword(txtPassword);
    this.validateConfirmPassword(txtPassword, inputConfirmPassword);

    if (validatePassword !== '') {
      this.setState({
        alertPassword: {
          type: validatePassword,
          isShow: true,
        },
      });
    } else {
      this.setState({
        alertPassword: {
          type: '',
          isShow: false,
        },
      });
    }

    this.setState({inputPassword: txtPassword});
  };

  onChangeInputConfirmPassword = (event) => {
    const {inputPassword} = this.state;

    const txtPassword = event.value.trim();
    this.validateConfirmPassword(inputPassword, txtPassword);

    this.setState({
      inputConfirmPassword: txtPassword,
    });
  };

  validateConfirmPassword = (password, confirmPassword) => {
    const validatePassword = this.validateRepeatPassword(password, confirmPassword);

    if (validatePassword !== '') {
      this.setState({
        alertConfirmPassword: {
          type: validatePassword,
          isShow: true,
        },
      });
    } else {
      this.setState({
        alertConfirmPassword: {
          type: '',
          isShow: false,
        },
      });
    }
  };

  onBlurInputName = () => {
    const {inputName} = this.state;
    const newVal = InputTextHelper.cleanUpInputText(inputName);
    this.setState({inputName: newVal});
  };

  onChangeInputName = (event) => {
    const {inputName} = this.state;
    const txtName = InputTextHelper.validateInputText(event.value, inputName);
    this.setState({inputName: txtName});
  };

  onChangeInputEmail = (event) => {
    const txtEmail = event.value.trim();
    const validatePassword = this.validateEmail(txtEmail);

    let alertEmail = {
      type: '',
      isShow: false,
    };
    if (validatePassword !== '') {
      alertEmail = {
        type: validatePassword,
        isShow: true,
      };
    } else {
      const isEmailAlreadyExist = this.availableUsers.find((user) => user.email === txtEmail);
      if (isEmailAlreadyExist) {
        alertEmail = {
          type: AlertEmail.EMAIL_ALREADY_EXIST,
          isShow: true,
        };
      }
    }
    this.setState({inputEmail: txtEmail, alertEmail});
  };

  onSelect = (event) => {
    const selectedOption = event;
    this.setState({roleName: selectedOption});
  };

  checkedChanged = (event) => {
    const isActivated = event.target.checked;
    this.setState({isActive: isActivated});
  };

  saveUserProfile = async () => {
    const {
      sessionStateUser,
      appStateActionShowLoading,
      appStateActionHideLoading,
      appStateActionShowSnackbar,
      sessionActionSetSessionUser,
      userManagementBusinessCreateUser,
      userManagementBusinessUpdateUser,
      userManagementBusinessUpdateUserNameAndEmail,
      intl,
      isEdit,
      isAccount,
      initialData,
      onSave,
    } = this.props;

    const {inputUsername, inputPassword, inputName, inputEmail, roleName, isActive, userId} = this.state;

    let showLoadingText;
    let response;

    if (isEdit || isAccount) {
      const editedUser = {
        UserId: userId,
        Username: inputUsername,
        Password: inputPassword,
        Name: inputName,
        Email: inputEmail,
        UserRole: roleName,
        IsActive: isActive,
      };

      showLoadingText = intl.formatMessage({id: 'loading.userManagement.addEditUserDialog.doUpdateUser'});
      appStateActionShowLoading(showLoadingText);

      if (isEdit) {
        response = await userManagementBusinessUpdateUser(editedUser);
      } else {
        response = await userManagementBusinessUpdateUserNameAndEmail(editedUser);
      }

      if (response) {
        let succesText = null;

        switch (response) {
          case ValidateResult.SUCCESS:
            appStateActionHideLoading();

            if (!isActive) {
              if (initialData.isActive) {
                succesText = intl.formatMessage({id: 'userManagement.editProfile.inActiveUser'});

                if (roleName === '1') {
                  succesText = intl.formatMessage({id: 'userManagement.editProfile.inActiveAdmin'});
                }
              }
            } else if (isAccount) {
              succesText = intl.formatMessage({id: 'userManagement.editProfile.success'});

              const newUserProfile = {...sessionStateUser};
              newUserProfile.email = inputEmail;
              newUserProfile.name = inputName;
              newUserProfile.decryptedPassword = inputPassword;

              sessionActionSetSessionUser(newUserProfile);
            }

            if (succesText) {
              appStateActionShowSnackbar(Feedback.SUCCESS, succesText, 2000);
            }

            onSave(true);
            return;
          case ValidateResult.EMAIL_ALREADY_EXIST:
            this.setState({
              alertEmail: {
                type: AlertEmail.EMAIL_ALREADY_EXIST,
                isShow: true,
              },
            });
            break;
          case ValidateResult.DOES_NOT_HAVE_PRIVILAGE:
            appStateActionHideLoading();
            onSave(false);
            return;
          default:
            break;
        }
      }

      appStateActionHideLoading();
    } else {
      showLoadingText = intl.formatMessage({id: 'loading.userManagement.addEditUserDialog.doCreateUser'});
      appStateActionShowLoading(showLoadingText);

      response = await userManagementBusinessCreateUser(
        inputUsername,
        inputPassword,
        inputName,
        inputEmail,
        roleName,
        isActive,
      );

      if (response) {
        switch (response) {
          case ValidateResult.SUCCESS:
            appStateActionHideLoading();
            onSave(true);
            return;
          case ValidateResult.USERNAME_ALREADY_EXIST:
            this.setState({
              alertUsername: {
                type: AlertUsername.USERNAME_EXIST,
                isShow: true,
              },
            });
            break;
          case ValidateResult.EMAIL_ALREADY_EXIST:
            this.setState({
              alertEmail: {
                type: AlertEmail.EMAIL_ALREADY_EXIST,
                isShow: true,
              },
            });
            break;
          case ValidateResult.DOES_NOT_HAVE_PRIVILAGE:
            appStateActionHideLoading();
            onSave(false);
            return;
          default:
            break;
        }
      }

      appStateActionHideLoading();
    }
  };

  handleSaveEdit = async () => {
    const {initialData, intl, appStateActionShowLoading, appStateActionHideLoading} = this.props;

    const {username} = initialData;

    appStateActionShowLoading();

    const isTargetUserBusy = await isUserBusy(username);

    appStateActionHideLoading();

    if (isTargetUserBusy) {
      const UserBusyBannerMessage = intl.formatMessage({id: 'userManagement.modal.banner.error'});

      await this.setState({
        banner: {
          isShow: true,
          message: UserBusyBannerMessage,
          variant: FmlxBanner.Variant.ERROR,
        },
      });

      this.bannerRef.current.scrollIntoView({
        behavior: 'smooth',
      });

      return;
    }

    this.saveUserProfile();
  };

  disabledFieldByRole = (Field) => {
    const {availableRoleRights} = this.props;
    const getRoleUser = _.find(availableRoleRights, {componentName: Field});

    if (getRoleUser) return true;

    return false;
  };

  disabledSaveBtn = () => {
    const {
      initialData,
      inputUsername,
      inputPassword,
      inputConfirmPassword,
      inputName,
      inputEmail,
      roleName,
      isActive,
      alertPassword,
      alertConfirmPassword,
      alertUsername,
      alertEmail,
    } = this.state;
    const {isAccount, isEdit} = this.props;
    if (!inputUsername || inputUsername === '') return true;
    if (!inputName || inputName === '') return true;
    if (!inputEmail || inputEmail === '') return true;
    if (!roleName || roleName === -1) return true;
    if (alertPassword.isShow) return true;
    if (alertUsername.isShow) return true;
    if (alertConfirmPassword.isShow) return true;
    if (alertEmail.isShow) return true;
    if (
      (isEdit || isAccount) &&
      inputUsername === initialData.username &&
      inputPassword === initialData.password &&
      inputConfirmPassword === initialData.confirmPassword &&
      inputName === initialData.name &&
      inputEmail === initialData.email &&
      roleName === initialData.userRole &&
      isActive === initialData.isActive
    )
      return true;
    if (!inputPassword || inputPassword === '') return true;
    if (!inputConfirmPassword || inputConfirmPassword === '') return true;
    return isAccount && this.disabledFieldByRole(ModalAccountRight.DISABLED_ALL_FIELD);
  };

  renderContent = () => {
    const {
      inputUsername,
      inputPassword,
      inputConfirmPassword,
      inputName,
      inputEmail,
      roleName,
      isActive,
      alertUsername,
      alertPassword,
      alertConfirmPassword,
      alertEmail,
      banner,
    } = this.state;
    const {
      isEdit,
      isAccount,
      availableRoles,
      availableRoleRights,
      userManagementBusinessFetchAvailableRoleRights,
      initialData,
    } = this.props;

    let roleOptions = availableRoles;

    if (roleOptions) {
      if (!roleOptions[0].text) {
        roleOptions = [];

        availableRoles.forEach((role) => {
          roleOptions.push({
            text: role.name,
            id: parseInt(role.id),
          });
        });
      }
    }

    const {variant: bannerVariant, message: bannerMsg, isShow: isShowBanner} = banner;

    return (
      <div className="usermanagement-adduser">
        <div ref={this.bannerRef} style={{marginBottom: '.5rem'}}>
          <FmlxBanner
            show={isShowBanner}
            title={bannerMsg}
            hideCloseButton
            variant={bannerVariant}
            size={FmlxBanner.Size.SMALL}
          />
        </div>
        <FormUserContainer
          inputUsername={inputUsername}
          inputPassword={inputPassword}
          inputConfirmPassword={inputConfirmPassword}
          inputName={inputName}
          inputEmail={inputEmail}
          initialUserRole={initialData.userRole}
          roleId={roleName}
          isActive={isActive}
          alertUsername={alertUsername}
          alertPassword={alertPassword}
          alertConfirmPassword={alertConfirmPassword}
          alertEmail={alertEmail}
          isEditUser={isEdit}
          onChangeInputUsername={this.onChangeInputUsername}
          onChangeInputPassword={this.onChangeInputPassword}
          onChangeInputConfirmPassword={this.onChangeInputConfirmPassword}
          onChangeInputName={this.onChangeInputName}
          onBlurInputName={this.onBlurInputName}
          onChangeInputEmail={this.onChangeInputEmail}
          onSelectRole={this.onSelect}
          checkedChangedActive={this.checkedChanged}
          isAccount={isAccount}
          availableRoles={roleOptions}
          availableRoleRights={availableRoleRights}
          onCheckUserRoleRights={userManagementBusinessFetchAvailableRoleRights}
          onInputKeyPressed={() => {
            if (!this.disabledSaveBtn()) {
              this.saveUserProfile();
            }
          }}
        />
      </div>
    );
  };

  renderHeader = () => {
    const {isEdit, isAccount} = this.props;

    if (isAccount) return 'ACCOUNT';
    if (isEdit) return 'EDIT USER';

    return 'CREATE NEW USER';
  };

  getTextCreateBtn = () => {
    const {isEdit, isAccount} = this.props;

    if (isEdit) return 'UPDATE';
    if (isAccount) return 'UPDATE';

    return 'CREATE';
  };

  render() {
    const {isEdit, showModal, onClose, appStateActionSetIsAnyModalShow} = this.props;
    const btnAction = [
      {
        text: this.getTextCreateBtn(),
        style: 'primary',
        handlerClick: async () => {
          if (isEdit) {
            this.handleSaveEdit();
            return;
          }
          this.saveUserProfile();
        },
        disabled: this.disabledSaveBtn(),
      },
      {
        text: 'CANCEL',
        style: 'secondary',
        handlerClick: () => {
          appStateActionSetIsAnyModalShow(false);
          onClose(true);
        },
      },
    ];

    return (
      <FastModal
        header={this.renderHeader()}
        content={this.renderContent()}
        btnAction={btnAction}
        show={showModal}
        className="create-rename"
        isValid
        closeDisabled
        size={ModalSize.LARGE}
      />
    );
  }
}

ModalAddEditUser.propTypes = {
  sessionStateUser: PropTypes.object.isRequired,
  appStateActionShowLoading: PropTypes.func.isRequired,
  appStateActionHideLoading: PropTypes.func.isRequired,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
  appStateActionSetIsAnyModalShow: PropTypes.func.isRequired,
  sessionActionSetSessionUser: PropTypes.func.isRequired,
  userManagementBusinessFetchUsers: PropTypes.func.isRequired,
  userManagementBusinessCreateUser: PropTypes.func.isRequired,
  userManagementBusinessUpdateUser: PropTypes.func.isRequired,
  userManagementBusinessUpdateUserNameAndEmail: PropTypes.func.isRequired,
  userManagementBusinessFetchAvailableRoleRights: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  isEdit: PropTypes.bool,
  isAccount: PropTypes.bool,
  initialData: PropTypes.object,
  availableRoleRights: PropTypes.array,
  availableRoles: PropTypes.array,
  showModal: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

ModalAddEditUser.defaultProps = {
  isEdit: false,
  isAccount: false,
  initialData: {},
  availableRoleRights: [],
  availableRoles: [],
  showModal: false,
  onSave: () => {},
  onClose: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(ModalAddEditUser));
